<template>
  <v-dialog
    :value="value"
    width="900px"
    persistent
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn 
            icon
            class="mr-2" 
            @click="$emit('input', false)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          Table Status
        </v-toolbar>
      </v-card-title>
      <api-errors :errors="errors" />
      <loading-bar v-if="!!awaitingApiResponse" />
      <div 
        v-else
        class="pa-2"
      >
        <v-row no-gutters>
          <template v-for="status in reservationStatusOptions">
            <v-col
              v-if="!status.hide"
              :key="'status-option-' + status.value"
              cols="12"
              sm="6"
              md="4"
              class="px-3 pt-3"
            >
              <v-card 
                class="d-flex justify-center smooth-background"
                :class="{'blue lighten-2': reservationStatus === status.value}"
                @click="$emit('set-reservation-status', status.value)"
              >
                <v-icon class="pa-3 black--text">
                  {{ (status.extData || {}).icon }}
                </v-icon>
                <div class="font-weight-bold d-flex align-self-center">
                  {{ status.text }}
                </div>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import floorPlanHelpers from '../mixins/floorPlanHelpers'
export default {
  name: 'ReservationStatusDialog',
  mixins: [floorPlanHelpers],
  props: {
    value: Boolean,
    reservationStatus: String,
    tableAssignments: {
      type: Array,
      default () {return []}
    }
  },
  data () {
    return {reservationStatusOptions: []}
  },
  computed: {
    reservationStatusOptionsMap () {
      return this.reservationStatusOptions?.reduce((acc, r) => {
        acc[r.value] = r
        return acc
      }, {}) ?? {}
    }
  },
  watch: {
    reservationStatus () {this.$emit('input', false)}
  },
  mounted () {
    this.awaitingApiResponse = true
    this.$ftAPI().get(this.addResourceErrorHandler({
      command: 'apiFieldOption',
      load: this.reservationStatusOptions,
      afterLoad: () => this.awaitingApiResponse = false,
      error: (r) => {
        this.awaitingApiResponse = false,
        this.errors.push(r.message)
      },
      loading: this.isLoading,
      params: {
        filter_methods: {forField: ['diningReservation', 'status']}
      }
    }))
  }
}
</script>

<style scoped>
.v-card::before {
  background: none;
}
.smooth-background {
  transition: background-color 0.2s ease-in-out;
}
</style>